import * as React from 'react';

import { HeaderNavigationProps } from '../Header/types';
import HeaderSlot from '../Header/HeaderSlot';
import SubNavigation from '../SubNavigation';

import styles from './HeaderNavigation.module.scss';
import cx from 'clsx';
import { CarouselSlider } from '../Carousel';
import { UserSessionProvider } from '../UserSessionProvider';

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
  items,
  onItemClick,
  navHorizontalPadding = 0,
  activeIndicatorColor,
  onNavigationCommandClick,
  onNavigationGameClick,
  onNavigationGameInfoClick,
  visible = true,
  onMenuItemClick,
  initialScrollValue,
  currentPagePath,
  pageTitle,
  loggedIn,
}) => {
  if (!visible) return null;
  const activeItem = items.find(
    item =>
      item.route_link === currentPagePath ||
      item.routes.find(r => r.route_link === currentPagePath)
  );

  return (
    <UserSessionProvider loggedIn={loggedIn}>
      <div
        className={cx(
          styles.wrapper,
          styles[`wrapper__${navHorizontalPadding}`],
          { [styles.wrapperNoResults]: !activeItem?.routes }
        )}
        data-testid="header-wrapper"
      >
        <div className={styles.mainNavContainer}>
          <CarouselSlider
            styleProp={'slider'}
            edgeSlidesPadding={navHorizontalPadding}
          >
            {items.map((item, index) => (
              <div
                className={styles.slot}
                key={index}
                data-testid={`${index}-slot`}
              >
                <HeaderSlot
                  data-testid={`${index}-header-slot`}
                  item={item}
                  onItemClick={onItemClick}
                  activeIndicatorColor={activeIndicatorColor}
                  onNavigationCommandClick={onNavigationCommandClick}
                  onNavigationGameClick={onNavigationGameClick}
                  onNavigationGameInfoClick={onNavigationGameInfoClick}
                  index={index}
                  pageTitle={pageTitle}
                />
              </div>
            ))}
          </CarouselSlider>
        </div>
        <SubNavigation
          items={activeItem?.routes || []}
          onMenuItemClick={onMenuItemClick}
          initialScrollValue={initialScrollValue}
        />
      </div>
    </UserSessionProvider>
  );
};

export default HeaderNavigation;
